<div class="custom-toast" [@flyInOut]="state()" (click)="tapToast()">

    <!-- Type icon (tick / cross / info / warning) -->
    <span class="toast-icon" [innerHTML]="iconSvg" aria-hidden="true"></span>
  
    <!-- Message -->
    <span
      class="toast-message"
      *ngIf="message"
      [innerHTML]="message"
      role="alert"
      [attr.aria-label]="message">
    </span>
  
    <!-- Optional action button rendered as a link -->
    <button
      *ngIf="options.payload?.actionText"
      class="toast-action"
      (click)="action($event)">
      {{ options.payload?.actionText }}
    </button>
  
    <!-- Close button -->
    <button
      *ngIf="options.closeButton"
      class="toast-close"
      (click)="remove()"
      aria-label="Close notification">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4L12 12M12 4L4 12" stroke="rgba(255,255,255,0.6)" stroke-width="1.5"
              stroke-linecap="round"/>
      </svg>
    </button>
  
  </div>